import { create } from 'zustand'
import { ESTADOS } from '../utils/constants'

export const useFiltersStore = create((set) => ({
  // Estado
  estadoEvento: ESTADOS.NUEVO,
  idCentroTrabajo: null, // null = todos los centros, número = centro específico
  idTipoAnomalia: null, // null = todos los tipos, número = tipo específico
  severidad: null, // null = todas las severidades, número = severidad específica
  idUsuarioCreador: null, // null = todos los autores, número = usuario específico
  textoBusqueda: '',
  page: 1,
  viewMode: 'grid', // 'grid' o 'list'

  // Acciones
  setEstadoEvento: (estado) => set({ estadoEvento: estado, page: 1 }),

  setIdCentroTrabajo: (id) => set({ idCentroTrabajo: id, page: 1 }),

  setIdTipoAnomalia: (id) => set({ idTipoAnomalia: id, page: 1 }),

  setSeveridad: (severidad) => set({ severidad, page: 1 }),

  setIdUsuarioCreador: (id) => set({ idUsuarioCreador: id, page: 1 }),

  setTextoBusqueda: (texto) => set({ textoBusqueda: texto, page: 1 }),

  setPage: (page) => set({ page }),

  setViewMode: (mode) => set({ viewMode: mode }),

  resetFilters: () =>
    set({
      estadoEvento: ESTADOS.NUEVO,
      idCentroTrabajo: null,
      idTipoAnomalia: null,
      severidad: null,
      idUsuarioCreador: null,
      textoBusqueda: '',
      page: 1,
    }),
}))
